import type * as mapboxgl from "mapbox-gl";

const STRIPE_WIDTH_PX = 1;
const STRIPE_LINE_PX = 2;
const STRIPE_GAP_PX = 5;
const STRIPE_HEIGHT_PX = STRIPE_LINE_PX + STRIPE_GAP_PX;

export function loadStripeFillPattern(map: mapboxgl.Map, color: string): string {
    const id = stripeFillPatternId(color);
    if (map.hasImage(id)) {
        return id;
    }

    const canvas = document.createElement("canvas");
    canvas.width = STRIPE_WIDTH_PX;
    canvas.height = STRIPE_HEIGHT_PX;

    const context = canvas.getContext("2d");
    if (!context) {
        return id;
    }

    context.fillStyle = color;
    context.fillRect(0, 0, STRIPE_WIDTH_PX, STRIPE_LINE_PX);

    const { data } = context.getImageData(0, 0, STRIPE_WIDTH_PX, STRIPE_HEIGHT_PX);
    map.addImage(id, { width: STRIPE_WIDTH_PX, height: STRIPE_HEIGHT_PX, data });

    return id;
}
export function stripeFillPatternId(color: string): string {
    return `stripeFillPattern-${color.replace("#", "")}`;
}
